<template>
  <div class="nav-large__wrap flex is-justify-space-between is-align-center">
    <!-- Logo -->
    <NuxtLink
      data-no-cursor
      :to="localePath({ name: 'index' })"
      :external="external"
      class="nav-large__logo"
    >
      <img
        :src="isScrolling ? GlyphLogoScroll : GlyphLogo"
        class="nav-large__logo-glyph"
        :alt="runtimeConfig.public.siteName"
      />
    </NuxtLink>

    <!-- Menu Left -->
    <div class="nav-large__list__wrap" @mouseleave="mouseLeave">
      <ul ref="nav" class="nav-large__list flex is-align-center">
        <li class="nav-large__list-main-link">
          <nuxt-link
            data-no-cursor
            :to="localePath({ name: 'sidri' })"
            class="text-nav"
            :external="external"
            :class="{ '--active': route.name?.includes('ciders-and-spirits') }"
            >{{ $t('menu.menu-nav.ciders-and-spirits') }}</nuxt-link
          >
        </li>
        <li class="nav-large__list-main-link">
          <nuxt-link
            data-no-cursor
            :to="localePath({ name: 'alta-quota' })"
            class="text-nav"
            :external="external"
            >{{ $t('menu.menu-nav.high-altitude') }}</nuxt-link
          >
        </li>
        <li class="nav-large__list-main-link">
          <nuxt-link
            data-no-cursor
            :to="localePath({ name: 'savoir-faire' })"
            class="text-nav"
            :external="external"
            >{{ $t('menu.menu-nav.savoir-faire') }}</nuxt-link
          >
        </li>
      </ul>
    </div>

    <!-- Menu Right -->
    <div class="nav-large__list__wrap" @mouseleave="mouseLeave">
      <ul ref="nav" class="nav-large__list flex is-align-center">
        <li class="nav-large__list-main-link">
          <nuxt-link
            data-no-cursor
            :to="localePath({ name: 'contatti' })"
            class="button-round-1-nav"
            :external="external"
            ><span>{{ props.ctaLabel || $t('menu.menu-nav.contacts') }}</span></nuxt-link
          >
        </li>

        <!-- Lang switch -->
        <li v-if="locales?.length" class="nav-large__list-lang-switch">
          <a
            v-for="localeObj in locales" :key="localeObj.code"
            class="text-corpo-l is-text-uppercase"
            :class="{
              '--active': locale === localeObj.code,
            }"
            href="#"
            @click.prevent.stop="handleLangSwitch(localeObj.code)"
          >
            <span>{{ localeObj.code }}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavigationMenuLarge',
}
</script>

<script setup>
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

import GlyphLogo from '@/assets/img/logos/logo-maley-red-ultimate-last.svg'
import GlyphLogoWhite from '@/assets/img/logos/logo-maley-red-ultimate-last.svg'
import GlyphLogoScroll from '@/assets/img/logos/maley-logo-red.svg'

gsap.registerPlugin(ScrollTrigger)

const switchLocalePath = useSwitchLocalePath()
const { locale, locales, setLocale } = useI18n()

const runtimeConfig = useRuntimeConfig()
const route = useRoute()

const lenis = inject('lenis')

const nav = ref(null)
const logo = ref(null)
const duration = 0.4
const isHover = ref(false)
const isNewPage = ref(true)

const props = defineProps({
  isLight: Boolean,
  isScrolling: Boolean,
  external: {
    type: Boolean,
    default: false,
  },
  ctaLabel: String
})

watch(
  () => isHover.value,
  (isHover) => {
    if (isHover) {
      // animateMenuIn().play()
    } else {
      if (lenis.value.scroll > 100 && !isNewPage.value) {
        // animateMenuOut().play()
      }
    }
  },
)

watch(
  () => route.path,
  () => {
    isNewPage.value = true
  },
)

onMounted(() => {
  isNewPage.value = false
})

const mouseLeave = () => {
  isHover.value = false
}

const navigate = () => {
  isHover.value = false
}

const handleLangSwitch = async (localeCode) => {
  isHover.value = false
  await setLocale(localeCode)
}
</script>

<style lang="scss">
@import './style.scss';
</style>
